export default __webpack_public_path__ + "static/media/CAAM.d2c81b42.png";